import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSocialMediaSettings } from "../../reducers/commonReducer";

const NotificationBar = () => {
  const dispatch = useDispatch();

  
  useEffect(() => {
    dispatch(getSocialMediaSettings());
  }, [dispatch]);

 
  const { getSocialMediaSettingsData } = useSelector(
    (state) => state.commonReducer
  );

  return (
    getSocialMediaSettingsData?.notification && (
      <div className="static-notification-bar success">
        <div className="container">
          <h6>{getSocialMediaSettingsData.notification}</h6>
        </div>
      </div>
    )
  );
};

export default NotificationBar;

